<template>
    <transition name="modal">
        <div class="modal-mask">
            <div class="modal-wrapper" @click="$emit('closeModal')">
                <div class="row">
                    <div class="col-xs-0 col-sm-0 col-md-1 col-lg-2"></div>
                    <div class="col-xs-12 col-sm-12 col-md-10 col-lg-8">
                        <div class="modal-container" @click.stop>
                            <div class="modal-body">
                                <div class="row">
                                    <div class="col-8">
                                        <h2
                                            class="title"
                                            style="margin-bottom: 20px"
                                        >
                                            {{data == null ? 'Add New' : 'Modify'}} Unit
                                            <!-- {{ data }} -->
                                        </h2>
                                    </div>
                                    <div class="offset-3 col-1">
                                        <button
                                            type="button"
                                            class="close"
                                            @click="$emit('closeModal')"
                                            style="
                                                font-size: 20px;
                                                color: #db5757;
                                                opacity: 1;
                                            "
                                        >
                                            <i class="fa fa-times"></i>
                                        </button>
                                    </div>
                                </div>
                                <div class="row row-space">
                                    <div
                                        class="col-xs-12 col-lg-6 first-field"
                                    >
                                        <div class="input-group">
                                            <label class="label"
                                                >Series </label
                                            >
                                            <input
                                                class="input--style-4"
                                                type="text"
                                                name="series"
                                                v-model="form.series"
                                                placeholder="Input Nama Series"
                                            />
                                        </div>
                                    </div>
                                    <div
                                        class="col-xs-12 col-lg-6 second-field"
                                    >
                                        <div class="input-group">
                                            <label class="label"
                                                >Type Code </label
                                            >
                                            <input
                                                class="input--style-4"
                                                type="text"
                                                name="type_code"
                                                v-model="form.type_code"
                                                :disabled="this.data"
                                                placeholder="Input Type Code"
                                            />
                                        </div>
                                    </div>
                                </div>
                                <div class="row row-space">
                                    <div
                                        class="col-xs-12 col-lg-6 first-field"
                                    >
                                        <div class="input-group">
                                            <label class="label"
                                                >Commercial Name </label
                                            >
                                            <input
                                                class="input--style-4"
                                                type="text"
                                                name="commercial_name"
                                                v-model="form.commercial_name"
                                                placeholder="Input Commercial Name"
                                            />
                                        </div>
                                    </div>
                                    <div
                                        class="col-xs-12 col-lg-6 second-field"
                                    >
                                        <div class="input-group">
                                            <label class="label"
                                                >Color Code </label
                                            >
                                            <input
                                                class="input--style-4"
                                                type="text"
                                                name="color_code"
                                                :disabled="this.data"
                                                v-model="form.color_code"
                                                placeholder="Input Color Code"
                                            />
                                        </div>
                                    </div>
                                </div>
                                <div class="row row-space">
                                    <div
                                        class="col-xs-12 col-lg-6 first-field"
                                    >
                                        <div class="input-group">
                                            <label class="label"
                                                >Color Description </label
                                            >
                                            <input
                                                class="input--style-4"
                                                type="text"
                                                name="color_desc"
                                                v-model="form.color_desc"
                                                placeholder="Input Color Description"
                                            />
                                        </div>
                                    </div>
                                    <div
                                        class="col-xs-12 col-lg-6 second-field"
                                    >
                                        <div class="input-group">
                                            <label class="label"
                                                >Status </label
                                            >
                                            <!-- <input
                                                class="input--style-4"
                                                type="text"
                                                name="status"
                                                v-model="form.type_code"
                                                placeholder="Input Commercial Name"
                                            /> -->
                                            <MultiSelect 
                                                :options="[1 , 0]"
                                                v-model="form.status"
                                                :multiple="false"
                                                :custom-label="opt => opt ? 'Active' : 'Inactive'"
                                                :allow-empty="false"
                                            />
                                        </div>
                                    </div>
                                </div>

                                <div class="row row-space">
                                    <div
                                        class="col-xs-12 col-lg-8 first-field"
                                    >
                                        <label class="label text-left"
                                            >Foto </label
                                        >
                                        <input
                                            class="input--style-4"
                                            type="file"
                                            name="file"
                                            @change="validateSize"
                                            placeholder="Input Color Code"
                                        />
                                    </div>
                                    <div
                                        class="col-xs-12 col-lg-4 second-field"
                                    >
                                        <img 
                                            :src="form.url_image"
                                            style="width:100%;height:auto;max-height: 200px;"
                                        />
                                        <!-- {{ form.url_image }} -->
                                    </div>
                                </div>
                                
                                <div class="row">
                                    <!-- <div class="col-lg-2 col-6 mt-3">
                                        <button
                                            type="button"
                                            class="btn btn-dark-blue w-100"
                                            @click="uploadExcel = true"
                                        >
                                            Upload Excel
                                        </button>
                                    </div>
                                    <div class="col-lg-3 col-6 mt-3">
                                        <a
                                            class="btn w-100"
                                            download
                                            href="/template-upload-user.xlsx"
                                        >
                                            <i class="fa fa-download"></i>
                                            Download Template
                                        </a>
                                    </div> -->
                                    <div
                                        class="offset-lg-8 col-lg-2 col-6 mt-3"
                                    >
                                        <button
                                            type="button"
                                            class="btn btn-dark-blue-outline w-100"
                                            @click="$emit('closeModal')"
                                        >
                                            Batal
                                        </button>
                                    </div>
                                    <div class="col-lg-2 col-6 mt-3 w-100">
                                        <button
                                            type="button"
                                            class="btn btn-green w-100"
                                            @click="submitForm()"
                                        >
                                            {{data == null ? 'Add' : 'Modify'}} Unit
                                        </button>
                                    </div>
                                </div>
						
                                <!-- Button Starts -->
                                
                                <!-- Button Ends -->
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-xs-0 col-sm-0 col-md-1 col-lg-2"></div>
            </div>
        </div>
    </transition>
</template>

<script>
import MultiSelect from 'vue-multiselect';
// import modulesList from './modulesList.json';

export default {
    data() {
        return {
            mobile: this.isMobile(),
            form: {
                type_code: '',
                series: '',
                commercial_name: '',
                color_code: '',
                color_desc: '',
                status: 1,
                url_image : null
            },
            moduleConfig: null,
            selectModule: [],
            structure: [],
            selected: [],
            uploadExcel: false,
			file : null
        };
    },
    directives: {
        indeterminate: function (el, binding) {
            el.indeterminate = Boolean(binding.value);
        }
    },
    components: {
        MultiSelect
    },
    mounted() {
        // this.generateStructure();
        if(this.data) {
            this.form = this.data
            this.form.status = this.data.status == 'Active' ? 1 : 0
        }   
        

    },
    watch: {},
    props : ['data'],
    methods: {
		validateSize : function(data){
            var file = data.dataTransfer ? data.dataTransfer.files[0] : data.target.files[0];
			// console.log(file)

            if(!file.type.includes('image/'))
            {
                this.$emit(
                    'triggerAlert',
                    true,
                    'Unsupported File Type! Only accepts Image Files'
                );
                return false;
            }

            var size  = file.size / 1024 / 1024;

            if(size > 8)
            {
                this.$emit(
                    'triggerAlert',
                    true,
                    'File size is too big'
                );
                return false;
            }

            this.fileError = "";
            this.file = file;
            this.form.url_image = URL.createObjectURL(file)
            return true;
        },
        async validateForm() {
            var valid = true;
            var error = [];

            if (this.form.series == '' || this.form.series == null) {
                //Full Name [Required]
                valid = false;
                error.push('  Series is a required Field!');
            }
            if (this.form.type_code == '' || this.form.type_code == null) {
                //Full Name [Required]
                valid = false;
                error.push('  Type Code is a required Field!');
            }
            if (this.form.commercial_name == '' || this.form.commercial_name == null) {
                //Full Name [Required]
                valid = false;
                error.push('  Commercial Name is a required Field!');
            }
            if (this.form.color_code == '' || this.form.color_code == null) {
                //Full Name [Required]
                valid = false;
                error.push('  Color Code is a required Field!');
            }
            if (this.form.color_desc == '' || this.form.color_desc == null) {
                //Full Name [Required]
                valid = false;
                error.push('  Color Description is a required Field!');
            }
            if (!valid) this.$emit('triggerAlert', !valid, error);
            else return valid;
        },
        async submitForm() {
            let vm = this;
            if (await vm.validateForm()) {

                var form_data = new FormData();

                for ( var key in vm.form ) {
                    form_data.append(key, vm.form[key]);
                }
                delete vm.form.url_image;

                if(vm.file) form_data.append('file' , vm.file)

                this.$http
                    .post('/api/save-series', form_data , {headers : {"Content-Type":'multipart/form-data'}})
                    .then((resp) => {
                        // alert(`Partshop ${vm.form.name} has been created`);
                        vm.$emit('triggerAlert', false, [
                            `Unit ${vm.form.series} has been created`
                        ]);
                        vm.$emit('closeModal')
                    })
                    .catch((err) => {
                        console.log(err);
                        vm.$emit(
                            'triggerAlert',
                            true,
                            err.data.message.split(',')
                        );
                    });
            }
        }
    }
};
</script>

<style scoped>
/* ==========================================================================
	#FORM made by Colorlib (https://colorlib.com)
	========================================================================== */
input {
    outline: none;
    margin: 0;
    border: none;
    -webkit-box-shadow: none;
    -moz-box-shadow: none;
    box-shadow: none;
    width: 100%;
    font-size: 14px;
    font-family: inherit;
}

.input--style-4 {
    line-height: 40px;
    background: #fff;
    /* -webkit-box-shadow: inset 0px 1px 3px 0px rgba(0, 0, 0, 0.08);
    -moz-box-shadow: inset 0px 1px 3px 0px rgba(0, 0, 0, 0.08);
    box-shadow: inset 0px 1px 3px 0px rgba(0, 0, 0, 0.08); */
    border : 1px solid #CECECE;
    -webkit-border-radius: 5px;
    -moz-border-radius: 5px;
    border-radius: 5px;
    padding: 0 20px;
    font-size: 16px;
    /* color: #666; */
    -webkit-transition: all 0.4s ease;
    -o-transition: all 0.4s ease;
    -moz-transition: all 0.4s ease;
    transition: all 0.4s ease;
}

.input--style-4:disabled {
    background: #d8d7d7;
}

.input--style-4::-webkit-input-placeholder {
    /* WebKit, Blink, Edge */
    color: #CECECE;
}

.input--style-4:-moz-placeholder {
    /* Mozilla Firefox 4 to 18 */
    color: #CECECE;
    opacity: 1;
}

.input--style-4::-moz-placeholder {
    /* Mozilla Firefox 19+ */
    color: #CECECE;
    opacity: 1;
}

.input--style-4:-ms-input-placeholder {
    /* Internet Explorer 10-11 */
    color: #CECECE;
}

.input--style-4:-ms-input-placeholder {
    /* Microsoft Edge */
    color: #CECECE;
}

.label {
    font-size: 12px;
    color: #5D5D5D;
    text-transform: capitalize;
    display: block;
    margin-bottom: 5px;
}

.radio-container {
    display: inline-block;
    position: relative;
    padding-left: 30px;
    cursor: pointer;
    font-size: 16px;
    color: #666;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
}

.radio-container input {
    position: absolute;
    opacity: 0;
    cursor: pointer;
}

.radio-container input:checked ~ .checkmark {
    background-color: #e5e5e5;
}

.radio-container input:checked ~ .checkmark:after {
    display: block;
}

.radio-container .checkmark:after {
    top: 50%;
    left: 50%;
    -webkit-transform: translate(-50%, -50%);
    -moz-transform: translate(-50%, -50%);
    -ms-transform: translate(-50%, -50%);
    -o-transform: translate(-50%, -50%);
    transform: translate(-50%, -50%);
    width: 12px;
    height: 12px;
    -webkit-border-radius: 50%;
    -moz-border-radius: 50%;
    border-radius: 50%;
    background: #57b846;
}

.checkmark {
    position: absolute;
    top: 50%;
    -webkit-transform: translateY(-50%);
    -moz-transform: translateY(-50%);
    -ms-transform: translateY(-50%);
    -o-transform: translateY(-50%);
    transform: translateY(-50%);
    left: 0;
    height: 20px;
    width: 20px;
    background-color: #e5e5e5;
    -webkit-border-radius: 50%;
    -moz-border-radius: 50%;
    border-radius: 50%;
    -webkit-box-shadow: inset 0px 1px 3px 0px rgba(0, 0, 0, 0.08);
    -moz-box-shadow: inset 0px 1px 3px 0px rgba(0, 0, 0, 0.08);
    box-shadow: inset 0px 1px 3px 0px rgba(0, 0, 0, 0.08);
}

.checkmark:after {
    content: '';
    position: absolute;
    display: none;
}

.input-group {
    position: relative;
    /* margin-bottom: 22px; */
    padding: 20px;
}

.input-group-icon {
    position: relative;
}

.input-icon {
    position: absolute;
    font-size: 18px;
    color: #999;
    right: 18px;
    top: 50%;
    -webkit-transform: translateY(-50%);
    -moz-transform: translateY(-50%);
    -ms-transform: translateY(-50%);
    -o-transform: translateY(-50%);
    transform: translateY(-50%);
    cursor: pointer;
}

/* ==========================================================================
	#TITLE made by Colorlib (https://colorlib.com)
	========================================================================== */
.title {
    font-size: 16px;
    color: #525252;
    margin-bottom: 40px;
    text-align: center;
}

.modal-body {
    max-height: 80vh;
    overflow-y: auto;
    overflow-x: auto;
}
.innerBox {
    padding: 1.5rem 1.5rem 1.5rem 2.25rem;
    border: 1px solid #eeeeee;
    border-radius: 5px;
    background-color: white;
    box-shadow: 2px 2px 5px #e0e0e0;
}
.custom-control {
    margin-bottom: 0;
}

.hoverable:hover {
    cursor: pointer;
}
.input-group {
    padding-left: 0;
    padding-right: 0;
}

.first-field {
    padding-right: 3.5%;
}

.second-field {
    padding-left: 3.5%;
}
.flex-middle {
	text-align: center;
}

.flex-middle-vertical {
    display: flex;
    justify-content: center;
}
</style>
